export const STEP_SIZE: number = 3
export const STEPS: number = 12
export const START_VALUES: Array<number> = [3, 2, 1]
export const RED_COLOR_CELLS = new Set<number>([1, 3, 5, 7, 9, 12, 14, 16, 18, 19, 21, 23, 25, 27, 30, 32, 34, 36])